import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/studioInfoSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { MembershipActivityRevenueTable } from "./smartComponents/MembershipActivityRevenueTable";
import { SalesActivityRevenueTable } from "./smartComponents/SalesActivityRevenueTable";
import { SalesActivityPieChart } from "./smartComponents/SalesActivityPieChart";
import { MembershipActivityPieChart } from "./smartComponents/MembershipActivityPieChart";
import { DataPoints } from "./smartComponents/DataPoints";
import { BookingsBreakdownComposedChart } from "./smartComponents/BookingsBreakdownComposedChart";
import { AttritionRateCallout } from "./smartComponents/AttritionRateCallout";
import { Bookings } from "./smartComponents/Bookings";
import { CustomDateRange } from "./smartComponents/CustomDateRange";
import { DatePicker } from "./smartComponents/DatePicker";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

import "./studioInfoModule.scss";

const StudioInfoModule = (props) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.studioInfo.isLoading);
  const updatesLoading = useSelector((state) => state.studioInfo.updatesLoading);

  const getData = () => {
    dispatch(actionCreators.fetchCurrentUser(props));
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div id="studio-info-root">
      <SectionToggle
        hideToggle
        autoHeight
        title="Studio Info"
        customClass="studioInfoWidget"
        isLoading={isLoading}
        content={
          <div>
            <div className="flex flex-col">
              <div className="edit-selections-bar" style={{ height: "150px" }}>
                <div>
                  <div className="select-box">
                    <p className="offers-title">Date Range</p>
                    <CustomDateRange />
                  </div>
                  <div className="date-select-box select-box multi">
                    <p className="offers-title">Date</p>
                    <DatePicker />
                  </div>
                </div>
                <div>
                  <UpdateBtns resetData={getData} />
                </div>
              </div>
            </div>
            {updatesLoading ? (
              <LoadingAnimation text="Updating data..." />
            ) : (
              <>
                <div className="container top-content-container">
                  <DataPoints />
                </div>
                <div className="container" id="studioInfoReportContainer">
                  <div className="section-group padding-right">
                    <h2 className="title">Membership Activity</h2>
                    <span className="pie-chart-wrapper">
                      <MembershipActivityPieChart />
                    </span>
                    <div className="studio-info-table-wrapper table-wrapper">
                      <MembershipActivityRevenueTable />
                    </div>
                    <AttritionRateCallout />
                  </div>
                  <div className="section-group">
                    <h2 className="title">Sales Breakdown</h2>
                    <span className="pie-chart-wrapper">
                      <SalesActivityPieChart />
                    </span>
                    <div className="studio-info-table-wrapper table-wrapper">
                      <SalesActivityRevenueTable />
                    </div>
                  </div>
                </div>
                <div className="container">
                  <Bookings />
                </div>
                <div className="container padding-bottom">
                  <BookingsBreakdownComposedChart />
                </div>
              </>
            )}
          </div>
        }
      />
    </div>
  );
};

export default StudioInfoModule;
